(function Module() {
	'use strict';

	var	_ = require('lodash');
	var log = require('parnell-log');
	var moment = require('moment');

	module.exports = {
		apply: function apply(app, config) {
			// required config.js items:
			//    cookies: {
			//    	applicationKey: 'application-unique key'
			//    	keys: [ 'cookie scope key1', 'cookie scope key2', ...]
			//    }
			function CookieFactory($cookies) {
				var self = this;

				function putCookie(cookie) {
					var key = cookie.applicationKey + '-' + cookie.key;

					localStorage.setItem(key, JSON.stringify(cookie));
				}

				function getCookie(cookie) {
					var key = cookie.applicationKey + '-' + cookie.key;
					var itemString = localStorage.getItem(key);

					if (itemString === null) {
						return undefined;
					}

					var item = JSON.parse(itemString);

					if (item.options && item.options.expires && +moment(item.options.expires) < +moment()) {
						localStorage.removeItem(key);

						return undefined;
					}

					return item.value;
				}

				function isReserved(cookie) {
					return _.contains(['load', 'save', 'clear'], cookie.key);
				}

				self.load = function loadCookies() {
					_.forEach(config.cookies, function loadCookie(configCookie) {
						var cookie = _.extend({}, configCookie);
						//TODO: cookies should specify their default type by a parameter now instead of this 'key[]' form
						var isArray = cookie.key.indexOf('[]') > -1;
						cookie.key = cookie.key.replace(/\[\]$/, '');

						if (isReserved(cookie)) {
							log.error('Error: reserved word \'' + cookie.key + '\' cannot be used as cookie name');
						} else {
							cookie.value = getCookie(cookie);

							if (_.isUndefined(cookie.value)) {
								cookie.value = isArray ? [] : {};
							}

							self[cookie.key] = cookie.value;
						}
					});
				};

				self.save = function saveCookies() {
					_.forEach(config.cookies, function saveCookie(configCookie) {
						var cookie = _.extend({}, configCookie);
						var isArray = cookie.key.indexOf('[]') > -1;
						cookie.key = cookie.key.replace(/\[\]$/, '');

						if (isReserved(cookie)) {
							log.error('Error: reserved word \'' + cookie.key + '\' cannot be used as cookie name');
						} else {
							cookie.value = self[cookie.key];

							if (_.isUndefined(cookie.value)) {
								cookie.value = isArray ? [] : {};
							}

							putCookie(cookie);
						}
					});
				};

				// Note: If the cookie you want to clear is an array, you will need to append brackets.
				// Example:
				// cookies.clear('dogs[]');
				// cookies.clear('parent');
				// cookies.clear(['parent', 'vet']);
				// cookies.clear();
				self.clear = function clearCookies(key) {
					var cookiesToClear = [];

					if (key) {
						if (!_.isArray(key)) {
							var cookie = {
								key: key
							};
							cookiesToClear.push(cookie);
						} else {
							_.forEach(key, function pushKey(key) {
								var cookie = {
									key: key
								};
								cookiesToClear.push(cookie);
							});
						}
					} else {
						cookiesToClear = config.cookies;
					}

					_.forEach(cookiesToClear, function clearCookie(configCookie) {
						var cookie = _.extend({}, configCookie);
						var isArray = cookie.key.indexOf('[]') > -1;
						cookie.key = cookie.key.replace(/\[\]$/, '');

						if (isReserved(cookie)) {
							log.error('Error: reserved word \'' + cookie.key + '\' cannot be used as cookie name');
						} else {
							self[cookie.key] = isArray ? [] : {};
						}
					});

					self.save();
				};

				self.load();

				return self;
			}

			app.factory('CookieFactory', ['$cookies', CookieFactory]);
		}
	};
})();
